import { render, staticRenderFns } from "./AssignedUsersCard.vue?vue&type=template&id=3109acec&"
import script from "./AssignedUsersCard.vue?vue&type=script&lang=js&"
export * from "./AssignedUsersCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports